/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Summary_Bar_Rate_WpmInputs */



/**
* | output |
* | --- |
* | "Words Per Minute (WPM)" |
*
* @param {Options_Metrics_Summary_Bar_Rate_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_summary_bar_rate_wpm = /** @type {((inputs?: Options_Metrics_Summary_Bar_Rate_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Summary_Bar_Rate_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
	return /** @type {LocalizedString} */ ("Words Per Minute (WPM)")
});